export default class HashUrl {
  constructor(fixedContent) {
    if (location.hash) {
      this.hash = location.hash;
    } else {
      this.hash = '';
    }

    if (fixedContent) {
      this.fixedCont = fixedContent;
      this.fixedContentHeight = this.fixedCont.clientHeight;
    } else {
      this.fixedContentHeight = 0;
    }

    this.init();
  }

  init() {
    if (this.hash.length != 0) {//hashがあれば
      let anchorTarget = document.querySelector(this.hash);
      if (anchorTarget) {
        // アンカー先がアコーディオンだったら開かせる
        if (anchorTarget.classList.contains('js-acc')) {
          const accBtn = anchorTarget.querySelector('.js-acc-btn');
          accBtn.setAttribute('aria-expanded', true);
          accBtn.click();
        }
        // アンカー先がモーダルだったら開かせる
        if (anchorTarget.classList.contains('mod-modal')) {
          anchorTarget.classList.remove('m-hidden');
        }
        window.scrollTo({
          top: anchorTarget.getBoundingClientRect().top + window.scrollY - this.fixedContentHeight,
          behavior: 'smooth',
        });
      }
    }
  }

}
